export default __webpack_public_path__ + "static/media/7.22.22da0329.jpg";